import { flow } from 'mobx-state-tree';

// Types
import { IdentifyingAccessTokenDecorated } from '@common/models/identifyingAccessTokens/types';

import http from '@clientCommon/bootstrap/http';

import { API_BASE } from '@clientCommon/constants';
import { MODEL_ROUTE } from '../../constants';

/**
 *
 */
export default flow(function* (identifyingAccessTokenId: string) {
  const response: IdentifyingAccessTokenDecorated = yield http.get({
    url: `${API_BASE}${MODEL_ROUTE}/${identifyingAccessTokenId}/decorated`,
  });

  return response;
});
